export default __webpack_public_path__ + "static/media/vest.5cc8b725.png";